<app-header [forceLightBackground]="true"></app-header>
<div class="admin-dashboard">
  <div class="admin-dashboard--layout">
    <app-admin-sidebar class="admin-dashboard--sidebar"></app-admin-sidebar>
    <div class="admin-dashboard--content">
      <app-page-header></app-page-header>
      <div class="page-container">
        @if (workspace.canViewPlatformSuperset()) {
        <section class="analytics-section">

          <div class="analytics-tabs">
            <button
              *ngFor="let dashboard of dashboards; trackBy: trackById"
              type="button"
              class="analytics-tab"
              [class.active]="!showSandbox && dashboard.id === selectedDashboard.id"
              (click)="selectDashboard(dashboard)"
            >
              {{ dashboard.title }}
            </button>
            <button
              type="button"
              class="analytics-tab"
              [class.active]="showSandbox"
              (click)="selectSandbox()"
            >
              Sandbox Usage
            </button>
          </div>

          <lib-sandbox-usage-dashboard *ngIf="showSandbox"></lib-sandbox-usage-dashboard>

          <!-- Superset panes stay mounted while the sandbox tab is open so embeds aren't reloaded. -->
          <div class="analytics-embed" [class.hidden]="showSandbox">
            <div
              *ngFor="let dashboard of dashboards; trackBy: trackById"
              class="analytics-embed--pane"
              [class.hidden]="dashboard.id !== selectedDashboard.id"
            >
              <div class="analytics-embed--loading" *ngIf="isLoading(dashboard.id)">
                <div class="analytics-embed--spinner"></div>
                <span>Loading dashboard...</span>
              </div>

              <div class="analytics-embed--error" *ngIf="getError(dashboard.id) as err">
                {{ err }}
              </div>

              <div
                #mount
                class="analytics-embed--mount"
                [class.hidden]="isLoading(dashboard.id) || !!getError(dashboard.id)"
              ></div>
            </div>
          </div>
        </section>
        }

        <!-- ΓöÇΓöÇ Recent Activities ΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇΓöÇ -->
        <div class="recent-activities">
          <div class="recent-activities__header">
            <h5 class="recent-activities__title">Recent Activities</h5>
            <a routerLink="/admin/activities" class="recent-activities__view-all">
              View All
              <img src="/arrow-right.svg" alt="Arrow right" width="16" height="16" />
            </a>
          </div>
          <app-activities
            [showFilters]="false"
            [pageSize]="5"
            [showPagination]="false"
            [disableSorting]="true"
            [showExportButton]="false"
          ></app-activities>
        </div>

      </div>
    </div>
  </div>
</div>
